// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file issues/v1/repo_issues_dashboard.proto (package github.issues.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { SafeHtml } from "../../common/v1/safe_html_pb";
import { file_common_v1_safe_html } from "../../common/v1/safe_html_pb";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file issues/v1/repo_issues_dashboard.proto.
 */
export const file_issues_v1_repo_issues_dashboard: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v1_safe_html, file_google_protobuf_wrappers]);

/**
 * Initial mixed issue and pull-request results required to render GET /:owner/:repo/issues.
 *
 * @generated from message github.issues.v1.RepoIssuesDashboardContentResponse
 */
export type RepoIssuesDashboardContentResponse = Message<"github.issues.v1.RepoIssuesDashboardContentResponse"> & {
  /**
   * @generated from field: repeated github.issues.v1.RepoIssuesDashboardResult results = 1;
   */
  results: RepoIssuesDashboardResult[];

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardPageInfo page_info = 2;
   */
  pageInfo?: RepoIssuesDashboardPageInfo;

  /**
   * @generated from field: google.protobuf.StringValue error = 3;
   */
  error?: string;

  /**
   * @generated from field: repeated github.issues.v1.RepoIssuesDashboardDeferredResult deferred = 4;
   */
  deferred: RepoIssuesDashboardDeferredResult[];

  /**
   * @generated from field: google.protobuf.StringValue issue_search_type = 5;
   */
  issueSearchType?: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardContentResponse.
 * Use `create(RepoIssuesDashboardContentResponseSchema)` to create a new message.
 */
export const RepoIssuesDashboardContentResponseSchema: GenMessage<RepoIssuesDashboardContentResponse> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 0);

/**
 * Secondary data used to fully enrich a row refreshed by global node ID.
 *
 * @generated from message github.issues.v1.RepoIssuesDashboardDeferredResult
 */
export type RepoIssuesDashboardDeferredResult = Message<"github.issues.v1.RepoIssuesDashboardDeferredResult"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardItemType item_type = 2;
   */
  itemType: RepoIssuesDashboardItemType;

  /**
   * @generated from oneof github.issues.v1.RepoIssuesDashboardDeferredResult.item
   */
  item: {
    /**
     * @generated from field: github.issues.v1.RepoIssueDeferred issue = 3;
     */
    value: RepoIssueDeferred;
    case: "issue";
  } | {
    /**
     * @generated from field: github.issues.v1.RepoIssuePullRequestDeferred pull_request = 4;
     */
    value: RepoIssuePullRequestDeferred;
    case: "pullRequest";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardDeferredResult.
 * Use `create(RepoIssuesDashboardDeferredResultSchema)` to create a new message.
 */
export const RepoIssuesDashboardDeferredResultSchema: GenMessage<RepoIssuesDashboardDeferredResult> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 1);

/**
 * @generated from message github.issues.v1.RepoIssueDeferred
 */
export type RepoIssueDeferred = Message<"github.issues.v1.RepoIssueDeferred"> & {
  /**
   * @generated from field: bool is_read_by_current_user = 1;
   */
  isReadByCurrentUser: boolean;

  /**
   * @generated from field: int32 linked_pull_request_count = 2;
   */
  linkedPullRequestCount: number;

  /**
   * @generated from field: repeated github.issues.v1.RepoIssueLinkedPullRequest linked_pull_requests = 3;
   */
  linkedPullRequests: RepoIssueLinkedPullRequest[];

  /**
   * @generated from field: github.issues.v1.RepoIssueSubIssuesSummary sub_issues_summary = 4;
   */
  subIssuesSummary?: RepoIssueSubIssuesSummary;

  /**
   * @generated from field: int32 blocked_by_count = 5;
   */
  blockedByCount: number;

  /**
   * @generated from field: github.issues.v1.RepoIssueReactionGroups reaction_groups = 6;
   */
  reactionGroups?: RepoIssueReactionGroups;
};

/**
 * Describes the message github.issues.v1.RepoIssueDeferred.
 * Use `create(RepoIssueDeferredSchema)` to create a new message.
 */
export const RepoIssueDeferredSchema: GenMessage<RepoIssueDeferred> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 2);

/**
 * @generated from message github.issues.v1.RepoIssuePullRequestDeferred
 */
export type RepoIssuePullRequestDeferred = Message<"github.issues.v1.RepoIssuePullRequestDeferred"> & {
  /**
   * @generated from field: github.issues.v1.RepoIssuePullRequestReviewDecision review_decision_state = 1;
   */
  reviewDecisionState: RepoIssuePullRequestReviewDecision;

  /**
   * @generated from field: github.issues.v1.RepoIssuePullRequestStatusCheckRollup status_check_rollup = 2;
   */
  statusCheckRollup?: RepoIssuePullRequestStatusCheckRollup;

  /**
   * @generated from field: google.protobuf.Int32Value approved_reviews_count = 3;
   */
  approvedReviewsCount?: number;

  /**
   * @generated from field: google.protobuf.Int32Value changes_requested_reviews_count = 4;
   */
  changesRequestedReviewsCount?: number;

  /**
   * @generated from field: github.issues.v1.RepoIssueReactionGroups reaction_groups = 5;
   */
  reactionGroups?: RepoIssueReactionGroups;
};

/**
 * Describes the message github.issues.v1.RepoIssuePullRequestDeferred.
 * Use `create(RepoIssuePullRequestDeferredSchema)` to create a new message.
 */
export const RepoIssuePullRequestDeferredSchema: GenMessage<RepoIssuePullRequestDeferred> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 3);

/**
 * @generated from message github.issues.v1.RepoIssueLinkedPullRequest
 */
export type RepoIssueLinkedPullRequest = Message<"github.issues.v1.RepoIssueLinkedPullRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: int32 number = 2;
   */
  number: number;

  /**
   * @generated from field: google.protobuf.StringValue permalink = 3;
   */
  permalink?: string;

  /**
   * @generated from field: google.protobuf.StringValue repo_name_with_owner = 4;
   */
  repoNameWithOwner?: string;

  /**
   * @generated from field: github.issues.v1.RepoIssuePullRequestState state = 5;
   */
  state: RepoIssuePullRequestState;

  /**
   * @generated from field: bool is_draft = 6;
   */
  isDraft: boolean;
};

/**
 * Describes the message github.issues.v1.RepoIssueLinkedPullRequest.
 * Use `create(RepoIssueLinkedPullRequestSchema)` to create a new message.
 */
export const RepoIssueLinkedPullRequestSchema: GenMessage<RepoIssueLinkedPullRequest> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 4);

/**
 * @generated from message github.issues.v1.RepoIssueSubIssuesSummary
 */
export type RepoIssueSubIssuesSummary = Message<"github.issues.v1.RepoIssueSubIssuesSummary"> & {
  /**
   * @generated from field: int32 total = 1;
   */
  total: number;

  /**
   * @generated from field: int32 completed = 2;
   */
  completed: number;

  /**
   * @generated from field: int32 percent_completed = 3;
   */
  percentCompleted: number;
};

/**
 * Describes the message github.issues.v1.RepoIssueSubIssuesSummary.
 * Use `create(RepoIssueSubIssuesSummarySchema)` to create a new message.
 */
export const RepoIssueSubIssuesSummarySchema: GenMessage<RepoIssueSubIssuesSummary> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 5);

/**
 * @generated from message github.issues.v1.RepoIssueReactionGroups
 */
export type RepoIssueReactionGroups = Message<"github.issues.v1.RepoIssueReactionGroups"> & {
  /**
   * @generated from field: repeated github.issues.v1.RepoIssueReactionGroup groups = 1;
   */
  groups: RepoIssueReactionGroup[];
};

/**
 * Describes the message github.issues.v1.RepoIssueReactionGroups.
 * Use `create(RepoIssueReactionGroupsSchema)` to create a new message.
 */
export const RepoIssueReactionGroupsSchema: GenMessage<RepoIssueReactionGroups> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 6);

/**
 * @generated from message github.issues.v1.RepoIssueReactionGroup
 */
export type RepoIssueReactionGroup = Message<"github.issues.v1.RepoIssueReactionGroup"> & {
  /**
   * @generated from field: string content = 1;
   */
  content: string;

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message github.issues.v1.RepoIssueReactionGroup.
 * Use `create(RepoIssueReactionGroupSchema)` to create a new message.
 */
export const RepoIssueReactionGroupSchema: GenMessage<RepoIssueReactionGroup> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 7);

/**
 * @generated from message github.issues.v1.RepoIssuePullRequestStatusCheckRollup
 */
export type RepoIssuePullRequestStatusCheckRollup = Message<"github.issues.v1.RepoIssuePullRequestStatusCheckRollup"> & {
  /**
   * @generated from field: github.issues.v1.RepoIssuePullRequestStatusCheckState state = 1;
   */
  state: RepoIssuePullRequestStatusCheckState;

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int32 success_count = 3;
   */
  successCount: number;
};

/**
 * Describes the message github.issues.v1.RepoIssuePullRequestStatusCheckRollup.
 * Use `create(RepoIssuePullRequestStatusCheckRollupSchema)` to create a new message.
 */
export const RepoIssuePullRequestStatusCheckRollupSchema: GenMessage<RepoIssuePullRequestStatusCheckRollup> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 8);

/**
 * Stable layout data shared by repository Issues routes.
 *
 * @generated from message github.issues.v1.RepoIssuesDashboardLayoutResponse
 */
export type RepoIssuesDashboardLayoutResponse = Message<"github.issues.v1.RepoIssuesDashboardLayoutResponse"> & {
  /**
   * @generated from field: bool has_projects_enabled = 1;
   */
  hasProjectsEnabled: boolean;

  /**
   * @generated from field: bool has_labels_archiving_enabled = 2;
   */
  hasLabelsArchivingEnabled: boolean;

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardCurrentUser current_user = 3;
   */
  currentUser?: RepoIssuesDashboardCurrentUser;

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardCurrentUserSettings current_user_settings = 4;
   */
  currentUserSettings?: RepoIssuesDashboardCurrentUserSettings;

  /**
   * @generated from field: google.protobuf.BoolValue sidebar_expanded = 5;
   */
  sidebarExpanded?: boolean;

  /**
   * @generated from field: repeated github.issues.v1.RepoIssuesDashboardPinnedView pinned_views = 6;
   */
  pinnedViews: RepoIssuesDashboardPinnedView[];

  /**
   * @generated from field: bool pinned_views_enabled = 7;
   */
  pinnedViewsEnabled: boolean;

  /**
   * @generated from field: bool best_match_sort_enabled = 8;
   */
  bestMatchSortEnabled: boolean;

  /**
   * @generated from field: bool issue_types_enabled = 9;
   */
  issueTypesEnabled: boolean;

  /**
   * @generated from field: google.protobuf.StringValue issue_search_type = 10;
   */
  issueSearchType?: string;

  /**
   * @generated from field: bool show_issue_field_pills = 11;
   */
  showIssueFieldPills: boolean;

  /**
   * @generated from field: bool viewer_can_create_issues = 12;
   */
  viewerCanCreateIssues: boolean;

  /**
   * @generated from field: bool is_writable = 13;
   */
  isWritable: boolean;

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardActions actions = 14;
   */
  actions?: RepoIssuesDashboardActions;

  /**
   * Server-read seed of the `dashboard_surface_compact_mode` cookie so the list
   * renders at the persisted density on first paint without a client-side flash.
   *
   * @generated from field: bool compact_mode = 15;
   */
  compactMode: boolean;

  /**
   * Repository pinned-issues strip (up to 3) and the viewer's pin capability.
   * Shown only on the repository view; absent on saved/filtered sidebar views.
   *
   * @generated from field: github.issues.v1.RepoIssuesDashboardPinnedIssues pinned_issues = 16;
   */
  pinnedIssues?: RepoIssuesDashboardPinnedIssues;

  /**
   * @generated from field: github.issues.v1.RepoIssuesFirstTimeContributionBanner first_time_contribution_banner = 17;
   */
  firstTimeContributionBanner?: RepoIssuesFirstTimeContributionBanner;

  /**
   * @generated from field: repeated string sso_organization_logins = 18;
   */
  ssoOrganizationLogins: string[];

  /**
   * Whether the viewer may apply repository-scoped bulk updates to issues.
   *
   * @generated from field: bool can_bulk_update = 19;
   */
  canBulkUpdate: boolean;

  /**
   * Global node ID used to scope query-wide bulk updates to this repository.
   *
   * @generated from field: string repository_id = 20;
   */
  repositoryId: string;

  /**
   * @generated from field: repeated string issue_status_names = 21;
   */
  issueStatusNames: string[];

  /**
   * @generated from field: repeated string issue_status_category_keys = 22;
   */
  issueStatusCategoryKeys: string[];
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardLayoutResponse.
 * Use `create(RepoIssuesDashboardLayoutResponseSchema)` to create a new message.
 */
export const RepoIssuesDashboardLayoutResponseSchema: GenMessage<RepoIssuesDashboardLayoutResponse> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 9);

/**
 * The repository pinned-issues strip: the ordered pinned issues and whether the
 * viewer may reorder/unpin them.
 *
 * @generated from message github.issues.v1.RepoIssuesDashboardPinnedIssues
 */
export type RepoIssuesDashboardPinnedIssues = Message<"github.issues.v1.RepoIssuesDashboardPinnedIssues"> & {
  /**
   * @generated from field: repeated github.issues.v1.RepoIssuesDashboardPinnedIssue issues = 1;
   */
  issues: RepoIssuesDashboardPinnedIssue[];

  /**
   * @generated from field: bool viewer_can_pin_issues = 2;
   */
  viewerCanPinIssues: boolean;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardPinnedIssues.
 * Use `create(RepoIssuesDashboardPinnedIssuesSchema)` to create a new message.
 */
export const RepoIssuesDashboardPinnedIssuesSchema: GenMessage<RepoIssuesDashboardPinnedIssues> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 10);

/**
 * A single pinned issue card. `id` is the issue global node id used as the mutation
 * identity for reorder/unpin.
 *
 * @generated from message github.issues.v1.RepoIssuesDashboardPinnedIssue
 */
export type RepoIssuesDashboardPinnedIssue = Message<"github.issues.v1.RepoIssuesDashboardPinnedIssue"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 number = 2;
   */
  number: number;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: github.common.v1.SafeHtml title_html = 4;
   */
  titleHtml?: SafeHtml;

  /**
   * @generated from field: string url = 5;
   */
  url: string;

  /**
   * @generated from field: github.issues.v1.RepoIssueState state = 6;
   */
  state: RepoIssueState;

  /**
   * @generated from field: github.issues.v1.RepoIssueStateReason state_reason = 7;
   */
  stateReason: RepoIssueStateReason;

  /**
   * @generated from field: github.issues.v1.RepoIssueAuthor author = 8;
   */
  author?: RepoIssueAuthor;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: int32 comment_count = 10;
   */
  commentCount: number;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardPinnedIssue.
 * Use `create(RepoIssuesDashboardPinnedIssueSchema)` to create a new message.
 */
export const RepoIssuesDashboardPinnedIssueSchema: GenMessage<RepoIssuesDashboardPinnedIssue> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 11);

/**
 * @generated from message github.issues.v1.RepoIssuesFirstTimeContributionBanner
 */
export type RepoIssuesFirstTimeContributionBanner = Message<"github.issues.v1.RepoIssuesFirstTimeContributionBanner"> & {
  /**
   * @generated from field: string repo_name_with_owner = 1;
   */
  repoNameWithOwner: string;

  /**
   * @generated from field: google.protobuf.StringValue contributing_guidelines_url = 2;
   */
  contributingGuidelinesUrl?: string;

  /**
   * @generated from field: bool has_good_first_issue_issues = 3;
   */
  hasGoodFirstIssueIssues: boolean;

  /**
   * @generated from field: string contribute_url = 4;
   */
  contributeUrl: string;

  /**
   * @generated from field: string dismiss_for_repo_url = 5;
   */
  dismissForRepoUrl: string;

  /**
   * @generated from field: string dismiss_for_all_url = 6;
   */
  dismissForAllUrl: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuesFirstTimeContributionBanner.
 * Use `create(RepoIssuesFirstTimeContributionBannerSchema)` to create a new message.
 */
export const RepoIssuesFirstTimeContributionBannerSchema: GenMessage<RepoIssuesFirstTimeContributionBanner> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 12);

/**
 * @generated from message github.issues.v1.RepoIssuesDashboardCurrentUser
 */
export type RepoIssuesDashboardCurrentUser = Message<"github.issues.v1.RepoIssuesDashboardCurrentUser"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string login = 2;
   */
  login: string;

  /**
   * @generated from field: google.protobuf.StringValue name = 3;
   */
  name?: string;

  /**
   * @generated from field: string avatar_url = 4;
   */
  avatarUrl: string;

  /**
   * @generated from field: bool is_emu = 5;
   */
  isEmu: boolean;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardCurrentUser.
 * Use `create(RepoIssuesDashboardCurrentUserSchema)` to create a new message.
 */
export const RepoIssuesDashboardCurrentUserSchema: GenMessage<RepoIssuesDashboardCurrentUser> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 13);

/**
 * @generated from message github.issues.v1.RepoIssuesDashboardCurrentUserSettings
 */
export type RepoIssuesDashboardCurrentUserSettings = Message<"github.issues.v1.RepoIssuesDashboardCurrentUserSettings"> & {
  /**
   * @generated from field: google.protobuf.Int32Value preferred_emoji_skin_tone = 1;
   */
  preferredEmojiSkinTone?: number;

  /**
   * @generated from field: bool copilot_show_functionality = 2;
   */
  copilotShowFunctionality: boolean;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardCurrentUserSettings.
 * Use `create(RepoIssuesDashboardCurrentUserSettingsSchema)` to create a new message.
 */
export const RepoIssuesDashboardCurrentUserSettingsSchema: GenMessage<RepoIssuesDashboardCurrentUserSettings> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 14);

/**
 * @generated from message github.issues.v1.RepoIssuesDashboardPinnedView
 */
export type RepoIssuesDashboardPinnedView = Message<"github.issues.v1.RepoIssuesDashboardPinnedView"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string icon = 3;
   */
  icon: string;

  /**
   * @generated from field: string color = 4;
   */
  color: string;

  /**
   * @generated from field: string visibility = 5;
   */
  visibility: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardPinnedView.
 * Use `create(RepoIssuesDashboardPinnedViewSchema)` to create a new message.
 */
export const RepoIssuesDashboardPinnedViewSchema: GenMessage<RepoIssuesDashboardPinnedView> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 15);

/**
 * @generated from message github.issues.v1.RepoIssuesDashboardActions
 */
export type RepoIssuesDashboardActions = Message<"github.issues.v1.RepoIssuesDashboardActions"> & {
  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardLink labels = 1 [deprecated = true];
   * @deprecated
   */
  labels?: RepoIssuesDashboardLink;

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardLink milestones = 2 [deprecated = true];
   * @deprecated
   */
  milestones?: RepoIssuesDashboardLink;

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardPrimaryAction new_issue = 3;
   */
  newIssue?: RepoIssuesDashboardPrimaryAction;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardActions.
 * Use `create(RepoIssuesDashboardActionsSchema)` to create a new message.
 */
export const RepoIssuesDashboardActionsSchema: GenMessage<RepoIssuesDashboardActions> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 16);

/**
 * @generated from message github.issues.v1.RepoIssuesDashboardLink
 */
export type RepoIssuesDashboardLink = Message<"github.issues.v1.RepoIssuesDashboardLink"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardLink.
 * Use `create(RepoIssuesDashboardLinkSchema)` to create a new message.
 */
export const RepoIssuesDashboardLinkSchema: GenMessage<RepoIssuesDashboardLink> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 17);

/**
 * @generated from message github.issues.v1.RepoIssuesDashboardPrimaryAction
 */
export type RepoIssuesDashboardPrimaryAction = Message<"github.issues.v1.RepoIssuesDashboardPrimaryAction"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: google.protobuf.StringValue url = 2;
   */
  url?: string;

  /**
   * @generated from field: google.protobuf.StringValue disabled_reason = 3;
   */
  disabledReason?: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardPrimaryAction.
 * Use `create(RepoIssuesDashboardPrimaryActionSchema)` to create a new message.
 */
export const RepoIssuesDashboardPrimaryActionSchema: GenMessage<RepoIssuesDashboardPrimaryAction> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 18);

/**
 * Owner-scoped Planning response. Rows and pagination intentionally share the
 * repository Issues contract so global node IDs remain the sole row identity.
 *
 * @generated from message github.issues.v1.PlanningIssuesContentResponse
 */
export type PlanningIssuesContentResponse = Message<"github.issues.v1.PlanningIssuesContentResponse"> & {
  /**
   * @generated from field: repeated github.issues.v1.RepoIssuesDashboardResult results = 1;
   */
  results: RepoIssuesDashboardResult[];

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardPageInfo page_info = 2;
   */
  pageInfo?: RepoIssuesDashboardPageInfo;

  /**
   * @generated from field: google.protobuf.StringValue error = 3;
   */
  error?: string;

  /**
   * @generated from field: repeated github.issues.v1.RepoIssuesDashboardDeferredResult deferred = 4;
   */
  deferred: RepoIssuesDashboardDeferredResult[];
};

/**
 * Describes the message github.issues.v1.PlanningIssuesContentResponse.
 * Use `create(PlanningIssuesContentResponseSchema)` to create a new message.
 */
export const PlanningIssuesContentResponseSchema: GenMessage<PlanningIssuesContentResponse> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 19);

/**
 * @generated from message github.issues.v1.RepoIssuesDashboardPageInfo
 */
export type RepoIssuesDashboardPageInfo = Message<"github.issues.v1.RepoIssuesDashboardPageInfo"> & {
  /**
   * @generated from field: int32 current_page = 1;
   */
  currentPage: number;

  /**
   * @generated from field: int32 total_pages = 2;
   */
  totalPages: number;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;

  /**
   * @generated from field: google.protobuf.Int32Value open_count = 4;
   */
  openCount?: number;

  /**
   * @generated from field: google.protobuf.Int32Value closed_count = 5;
   */
  closedCount?: number;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardPageInfo.
 * Use `create(RepoIssuesDashboardPageInfoSchema)` to create a new message.
 */
export const RepoIssuesDashboardPageInfoSchema: GenMessage<RepoIssuesDashboardPageInfo> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 20);

/**
 * The global node ID is the canonical identity for either row type.
 *
 * @generated from message github.issues.v1.RepoIssuesDashboardResult
 */
export type RepoIssuesDashboardResult = Message<"github.issues.v1.RepoIssuesDashboardResult"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardItemType item_type = 2;
   */
  itemType: RepoIssuesDashboardItemType;

  /**
   * @generated from oneof github.issues.v1.RepoIssuesDashboardResult.item
   */
  item: {
    /**
     * @generated from field: github.issues.v1.RepoIssue issue = 3;
     */
    value: RepoIssue;
    case: "issue";
  } | {
    /**
     * @generated from field: github.issues.v1.RepoIssuePullRequest pull_request = 4;
     */
    value: RepoIssuePullRequest;
    case: "pullRequest";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardResult.
 * Use `create(RepoIssuesDashboardResultSchema)` to create a new message.
 */
export const RepoIssuesDashboardResultSchema: GenMessage<RepoIssuesDashboardResult> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 21);

/**
 * @generated from message github.issues.v1.RepoIssue
 */
export type RepoIssue = Message<"github.issues.v1.RepoIssue"> & {
  /**
   * @generated from field: int32 number = 1;
   */
  number: number;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: github.common.v1.SafeHtml title_html = 3;
   */
  titleHtml?: SafeHtml;

  /**
   * @generated from field: github.issues.v1.RepoIssueState state = 4;
   */
  state: RepoIssueState;

  /**
   * @generated from field: github.issues.v1.RepoIssueStateReason state_reason = 5;
   */
  stateReason: RepoIssueStateReason;

  /**
   * @generated from field: bool closed = 6;
   */
  closed: boolean;

  /**
   * @generated from field: google.protobuf.StringValue closed_at = 7;
   */
  closedAt?: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 9;
   */
  updatedAt: string;

  /**
   * @generated from field: int32 comment_count = 10;
   */
  commentCount: number;

  /**
   * @generated from field: google.protobuf.StringValue permalink = 11;
   */
  permalink?: string;

  /**
   * @generated from field: google.protobuf.StringValue repo_name_with_owner = 12;
   */
  repoNameWithOwner?: string;

  /**
   * @generated from field: repeated github.issues.v1.RepoIssuesDashboardLabel labels = 13;
   */
  labels: RepoIssuesDashboardLabel[];

  /**
   * @generated from field: repeated github.issues.v1.RepoIssueAssignee assignees = 14;
   */
  assignees: RepoIssueAssignee[];

  /**
   * @generated from field: github.issues.v1.RepoIssueAuthor author = 15;
   */
  author?: RepoIssueAuthor;

  /**
   * @generated from field: github.issues.v1.RepoIssueType issue_type = 16;
   */
  issueType?: RepoIssueType;

  /**
   * @generated from field: github.issues.v1.RepoIssueMilestone milestone = 17;
   */
  milestone?: RepoIssueMilestone;

  /**
   * @generated from field: repeated github.issues.v1.RepoIssueFieldValue issue_field_values = 18;
   */
  issueFieldValues: RepoIssueFieldValue[];

  /**
   * @generated from field: google.protobuf.StringValue alive_channel = 19;
   */
  aliveChannel?: string;

  /**
   * @generated from field: bool is_account_issue = 20;
   */
  isAccountIssue: boolean;
};

/**
 * Describes the message github.issues.v1.RepoIssue.
 * Use `create(RepoIssueSchema)` to create a new message.
 */
export const RepoIssueSchema: GenMessage<RepoIssue> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 22);

/**
 * @generated from message github.issues.v1.RepoIssuePullRequest
 */
export type RepoIssuePullRequest = Message<"github.issues.v1.RepoIssuePullRequest"> & {
  /**
   * @generated from field: int32 number = 1;
   */
  number: number;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: github.common.v1.SafeHtml title_html = 3;
   */
  titleHtml?: SafeHtml;

  /**
   * @generated from field: github.issues.v1.RepoIssuePullRequestState state = 4;
   */
  state: RepoIssuePullRequestState;

  /**
   * @generated from field: github.issues.v1.RepoIssuePullRequestDisplayState display_state = 5;
   */
  displayState: RepoIssuePullRequestDisplayState;

  /**
   * @generated from field: bool is_draft = 6;
   */
  isDraft: boolean;

  /**
   * @generated from field: bool is_read_by_current_user = 7;
   */
  isReadByCurrentUser: boolean;

  /**
   * @generated from field: google.protobuf.StringValue permalink = 8;
   */
  permalink?: string;

  /**
   * @generated from field: google.protobuf.StringValue repo_name_with_owner = 9;
   */
  repoNameWithOwner?: string;

  /**
   * @generated from field: repeated github.issues.v1.RepoIssuesDashboardLabel labels = 10;
   */
  labels: RepoIssuesDashboardLabel[];

  /**
   * @generated from field: repeated github.issues.v1.RepoIssuePullRequestAssignee assignees = 11;
   */
  assignees: RepoIssuePullRequestAssignee[];

  /**
   * @generated from field: github.issues.v1.RepoIssuePullRequestAuthor author = 12;
   */
  author?: RepoIssuePullRequestAuthor;

  /**
   * @generated from field: github.issues.v1.RepoIssuePullRequestAgentAttributedUser agent_attributed_user = 13;
   */
  agentAttributedUser?: RepoIssuePullRequestAgentAttributedUser;

  /**
   * @generated from field: int32 comment_count = 14;
   */
  commentCount: number;

  /**
   * @generated from field: google.protobuf.StringValue commit_head_sha_channel = 15;
   */
  commitHeadShaChannel?: string;

  /**
   * @generated from field: string created_at = 16;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 17;
   */
  updatedAt: string;

  /**
   * @generated from field: google.protobuf.StringValue head_sha = 18;
   */
  headSha?: string;

  /**
   * @generated from field: google.protobuf.Int32Value stack_position = 19;
   */
  stackPosition?: number;

  /**
   * @generated from field: google.protobuf.Int32Value stack_size = 20;
   */
  stackSize?: number;

  /**
   * @generated from field: google.protobuf.StringValue alive_channel = 21;
   */
  aliveChannel?: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuePullRequest.
 * Use `create(RepoIssuePullRequestSchema)` to create a new message.
 */
export const RepoIssuePullRequestSchema: GenMessage<RepoIssuePullRequest> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 23);

/**
 * @generated from message github.issues.v1.RepoIssuesDashboardLabel
 */
export type RepoIssuesDashboardLabel = Message<"github.issues.v1.RepoIssuesDashboardLabel"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.StringValue color = 3;
   */
  color?: string;

  /**
   * @generated from field: google.protobuf.StringValue description = 4;
   */
  description?: string;

  /**
   * @generated from field: github.common.v1.SafeHtml name_html = 5;
   */
  nameHtml?: SafeHtml;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardLabel.
 * Use `create(RepoIssuesDashboardLabelSchema)` to create a new message.
 */
export const RepoIssuesDashboardLabelSchema: GenMessage<RepoIssuesDashboardLabel> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 24);

/**
 * @generated from message github.issues.v1.RepoIssueAssignee
 */
export type RepoIssueAssignee = Message<"github.issues.v1.RepoIssueAssignee"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string login = 2;
   */
  login: string;

  /**
   * @generated from field: google.protobuf.StringValue name = 3;
   */
  name?: string;

  /**
   * @generated from field: string avatar_url = 4;
   */
  avatarUrl: string;

  /**
   * @generated from field: string profile_resource_path = 5;
   */
  profileResourcePath: string;

  /**
   * @generated from field: bool is_copilot = 6;
   */
  isCopilot: boolean;

  /**
   * @generated from field: bool is_agent = 7;
   */
  isAgent: boolean;
};

/**
 * Describes the message github.issues.v1.RepoIssueAssignee.
 * Use `create(RepoIssueAssigneeSchema)` to create a new message.
 */
export const RepoIssueAssigneeSchema: GenMessage<RepoIssueAssignee> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 25);

/**
 * @generated from message github.issues.v1.RepoIssueAuthor
 */
export type RepoIssueAuthor = Message<"github.issues.v1.RepoIssueAuthor"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * @generated from field: google.protobuf.StringValue name = 2;
   */
  name?: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;

  /**
   * @generated from field: string resource_path = 4;
   */
  resourcePath: string;

  /**
   * @generated from field: string typename = 5;
   */
  typename: string;

  /**
   * @generated from field: bool is_copilot = 6;
   */
  isCopilot: boolean;

  /**
   * @generated from field: bool is_agent = 7;
   */
  isAgent: boolean;
};

/**
 * Describes the message github.issues.v1.RepoIssueAuthor.
 * Use `create(RepoIssueAuthorSchema)` to create a new message.
 */
export const RepoIssueAuthorSchema: GenMessage<RepoIssueAuthor> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 26);

/**
 * @generated from message github.issues.v1.RepoIssueType
 */
export type RepoIssueType = Message<"github.issues.v1.RepoIssueType"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string color = 2;
   */
  color: string;

  /**
   * @generated from field: string id = 3;
   */
  id: string;
};

/**
 * Describes the message github.issues.v1.RepoIssueType.
 * Use `create(RepoIssueTypeSchema)` to create a new message.
 */
export const RepoIssueTypeSchema: GenMessage<RepoIssueType> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 27);

/**
 * @generated from message github.issues.v1.RepoIssueMilestone
 */
export type RepoIssueMilestone = Message<"github.issues.v1.RepoIssueMilestone"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string id = 3;
   */
  id: string;
};

/**
 * Describes the message github.issues.v1.RepoIssueMilestone.
 * Use `create(RepoIssueMilestoneSchema)` to create a new message.
 */
export const RepoIssueMilestoneSchema: GenMessage<RepoIssueMilestone> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 28);

/**
 * @generated from message github.issues.v1.RepoIssueFieldValue
 */
export type RepoIssueFieldValue = Message<"github.issues.v1.RepoIssueFieldValue"> & {
  /**
   * @generated from field: string field_name = 1;
   */
  fieldName: string;

  /**
   * @generated from field: string data_type = 2;
   */
  dataType: string;

  /**
   * @generated from field: google.protobuf.StringValue value = 3;
   */
  value?: string;

  /**
   * @generated from field: google.protobuf.DoubleValue number_value = 4;
   */
  numberValue?: number;

  /**
   * @generated from field: repeated string options = 5;
   */
  options: string[];
};

/**
 * Describes the message github.issues.v1.RepoIssueFieldValue.
 * Use `create(RepoIssueFieldValueSchema)` to create a new message.
 */
export const RepoIssueFieldValueSchema: GenMessage<RepoIssueFieldValue> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 29);

/**
 * @generated from message github.issues.v1.RepoIssuePullRequestAssignee
 */
export type RepoIssuePullRequestAssignee = Message<"github.issues.v1.RepoIssuePullRequestAssignee"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * @generated from field: string avatar_url = 2;
   */
  avatarUrl: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuePullRequestAssignee.
 * Use `create(RepoIssuePullRequestAssigneeSchema)` to create a new message.
 */
export const RepoIssuePullRequestAssigneeSchema: GenMessage<RepoIssuePullRequestAssignee> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 30);

/**
 * @generated from message github.issues.v1.RepoIssuePullRequestAuthor
 */
export type RepoIssuePullRequestAuthor = Message<"github.issues.v1.RepoIssuePullRequestAuthor"> & {
  /**
   * @generated from field: string display_login = 1;
   */
  displayLogin: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuePullRequestAuthor.
 * Use `create(RepoIssuePullRequestAuthorSchema)` to create a new message.
 */
export const RepoIssuePullRequestAuthorSchema: GenMessage<RepoIssuePullRequestAuthor> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 31);

/**
 * @generated from message github.issues.v1.RepoIssuePullRequestAgentAttributedUser
 */
export type RepoIssuePullRequestAgentAttributedUser = Message<"github.issues.v1.RepoIssuePullRequestAgentAttributedUser"> & {
  /**
   * @generated from field: string display_login = 1;
   */
  displayLogin: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuePullRequestAgentAttributedUser.
 * Use `create(RepoIssuePullRequestAgentAttributedUserSchema)` to create a new message.
 */
export const RepoIssuePullRequestAgentAttributedUserSchema: GenMessage<RepoIssuePullRequestAgentAttributedUser> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 32);

/**
 * @generated from enum github.issues.v1.RepoIssuesDashboardItemType
 */
export enum RepoIssuesDashboardItemType {
  /**
   * @generated from enum value: REPO_ISSUES_DASHBOARD_ITEM_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_ISSUES_DASHBOARD_ITEM_TYPE_ISSUE = 1;
   */
  ISSUE = 1,

  /**
   * @generated from enum value: REPO_ISSUES_DASHBOARD_ITEM_TYPE_PULL_REQUEST = 2;
   */
  PULL_REQUEST = 2,
}

/**
 * Describes the enum github.issues.v1.RepoIssuesDashboardItemType.
 */
export const RepoIssuesDashboardItemTypeSchema: GenEnum<RepoIssuesDashboardItemType> = /*@__PURE__*/
  enumDesc(file_issues_v1_repo_issues_dashboard, 0);

/**
 * @generated from enum github.issues.v1.RepoIssueState
 */
export enum RepoIssueState {
  /**
   * @generated from enum value: REPO_ISSUE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_ISSUE_STATE_OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: REPO_ISSUE_STATE_CLOSED = 2;
   */
  CLOSED = 2,
}

/**
 * Describes the enum github.issues.v1.RepoIssueState.
 */
export const RepoIssueStateSchema: GenEnum<RepoIssueState> = /*@__PURE__*/
  enumDesc(file_issues_v1_repo_issues_dashboard, 1);

/**
 * @generated from enum github.issues.v1.RepoIssueStateReason
 */
export enum RepoIssueStateReason {
  /**
   * @generated from enum value: REPO_ISSUE_STATE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_ISSUE_STATE_REASON_COMPLETED = 1;
   */
  COMPLETED = 1,

  /**
   * @generated from enum value: REPO_ISSUE_STATE_REASON_NOT_PLANNED = 2;
   */
  NOT_PLANNED = 2,

  /**
   * @generated from enum value: REPO_ISSUE_STATE_REASON_REOPENED = 3;
   */
  REOPENED = 3,

  /**
   * @generated from enum value: REPO_ISSUE_STATE_REASON_DUPLICATE = 4;
   */
  DUPLICATE = 4,
}

/**
 * Describes the enum github.issues.v1.RepoIssueStateReason.
 */
export const RepoIssueStateReasonSchema: GenEnum<RepoIssueStateReason> = /*@__PURE__*/
  enumDesc(file_issues_v1_repo_issues_dashboard, 2);

/**
 * @generated from enum github.issues.v1.RepoIssuePullRequestState
 */
export enum RepoIssuePullRequestState {
  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_STATE_OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_STATE_CLOSED = 2;
   */
  CLOSED = 2,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_STATE_MERGED = 3;
   */
  MERGED = 3,
}

/**
 * Describes the enum github.issues.v1.RepoIssuePullRequestState.
 */
export const RepoIssuePullRequestStateSchema: GenEnum<RepoIssuePullRequestState> = /*@__PURE__*/
  enumDesc(file_issues_v1_repo_issues_dashboard, 3);

/**
 * @generated from enum github.issues.v1.RepoIssuePullRequestDisplayState
 */
export enum RepoIssuePullRequestDisplayState {
  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_DISPLAY_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_DISPLAY_STATE_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_DISPLAY_STATE_OPEN = 2;
   */
  OPEN = 2,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_DISPLAY_STATE_CLOSED = 3;
   */
  CLOSED = 3,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_DISPLAY_STATE_MERGED = 4;
   */
  MERGED = 4,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_DISPLAY_STATE_QUEUED = 5;
   */
  QUEUED = 5,
}

/**
 * Describes the enum github.issues.v1.RepoIssuePullRequestDisplayState.
 */
export const RepoIssuePullRequestDisplayStateSchema: GenEnum<RepoIssuePullRequestDisplayState> = /*@__PURE__*/
  enumDesc(file_issues_v1_repo_issues_dashboard, 4);

/**
 * @generated from enum github.issues.v1.RepoIssuePullRequestReviewDecision
 */
export enum RepoIssuePullRequestReviewDecision {
  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_REVIEW_DECISION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_REVIEW_DECISION_APPROVED = 1;
   */
  APPROVED = 1,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_REVIEW_DECISION_CHANGES_REQUESTED = 2;
   */
  CHANGES_REQUESTED = 2,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_REVIEW_DECISION_REQUIRED = 3;
   */
  REQUIRED = 3,
}

/**
 * Describes the enum github.issues.v1.RepoIssuePullRequestReviewDecision.
 */
export const RepoIssuePullRequestReviewDecisionSchema: GenEnum<RepoIssuePullRequestReviewDecision> = /*@__PURE__*/
  enumDesc(file_issues_v1_repo_issues_dashboard, 5);

/**
 * @generated from enum github.issues.v1.RepoIssuePullRequestStatusCheckState
 */
export enum RepoIssuePullRequestStatusCheckState {
  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_STATUS_CHECK_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_STATUS_CHECK_STATE_SUCCESS = 1;
   */
  SUCCESS = 1,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_STATUS_CHECK_STATE_FAILURE = 2;
   */
  FAILURE = 2,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_STATUS_CHECK_STATE_PENDING = 3;
   */
  PENDING = 3,
}

/**
 * Describes the enum github.issues.v1.RepoIssuePullRequestStatusCheckState.
 */
export const RepoIssuePullRequestStatusCheckStateSchema: GenEnum<RepoIssuePullRequestStatusCheckState> = /*@__PURE__*/
  enumDesc(file_issues_v1_repo_issues_dashboard, 6);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(RepoIssuesDashboardContentResponseSchema, "908ce943f6b7")
registerSchemaHash(RepoIssuesDashboardDeferredResultSchema, "e24a103267e4")
registerSchemaHash(RepoIssueDeferredSchema, "bf0d9d43e0d2")
registerSchemaHash(RepoIssuePullRequestDeferredSchema, "252f68a98328")
registerSchemaHash(RepoIssueLinkedPullRequestSchema, "63edccadd9ab")
registerSchemaHash(RepoIssueSubIssuesSummarySchema, "227c4d00b01e")
registerSchemaHash(RepoIssueReactionGroupsSchema, "ff9a1db4b5f8")
registerSchemaHash(RepoIssueReactionGroupSchema, "b9d6d027857c")
registerSchemaHash(RepoIssuePullRequestStatusCheckRollupSchema, "2d2b9f7cf9d3")
registerSchemaHash(RepoIssuesDashboardLayoutResponseSchema, "492799e2ca57")
registerSchemaHash(RepoIssuesDashboardPinnedIssuesSchema, "c4ec99804123")
registerSchemaHash(RepoIssuesDashboardPinnedIssueSchema, "0616b2fde2fc")
registerSchemaHash(RepoIssuesFirstTimeContributionBannerSchema, "4a8b627e40ab")
registerSchemaHash(RepoIssuesDashboardCurrentUserSchema, "a742096e42af")
registerSchemaHash(RepoIssuesDashboardCurrentUserSettingsSchema, "04ef92813d08")
registerSchemaHash(RepoIssuesDashboardPinnedViewSchema, "1cc1f44cf0ce")
registerSchemaHash(RepoIssuesDashboardActionsSchema, "4a6f44a51a48")
registerSchemaHash(RepoIssuesDashboardLinkSchema, "fc077b9d9059")
registerSchemaHash(RepoIssuesDashboardPrimaryActionSchema, "a3b1ec5ae3f3")
registerSchemaHash(PlanningIssuesContentResponseSchema, "1b8b9ee0955c")
registerSchemaHash(RepoIssuesDashboardPageInfoSchema, "a57eb4a26177")
registerSchemaHash(RepoIssuesDashboardResultSchema, "19987ec5e015")
registerSchemaHash(RepoIssueSchema, "696d74770408")
registerSchemaHash(RepoIssuePullRequestSchema, "52232777829a")
registerSchemaHash(RepoIssuesDashboardLabelSchema, "5c865bbc0277")
registerSchemaHash(RepoIssueAssigneeSchema, "d3a1f3d76952")
registerSchemaHash(RepoIssueAuthorSchema, "30e53e2b23a5")
registerSchemaHash(RepoIssueTypeSchema, "2d0c6aee516a")
registerSchemaHash(RepoIssueMilestoneSchema, "6a71ffb0bef9")
registerSchemaHash(RepoIssueFieldValueSchema, "5ef17d051b2d")
registerSchemaHash(RepoIssuePullRequestAssigneeSchema, "2e9062ec2cc7")
registerSchemaHash(RepoIssuePullRequestAuthorSchema, "4437cfe15693")
registerSchemaHash(RepoIssuePullRequestAgentAttributedUserSchema, "5b0013c56776")
